import { actionTypes } from '../index';
import { IAgreementData } from '../initialState';

export const setAgreementData = ({
    agreementId,
    agreementNumber,
    isDouble,
    hasError,
    errorMessage,
}: IAgreementData) => ({
    type: actionTypes.SET_AGREEMENT_DATA,
    payload: {
        agreementId,
        agreementNumber,
        isDouble,
        hasError,
        errorMessage,
    },
});
